export const inst = "https://www.instagram.com/about.u.kraine/";
export const tt = "https://www.tiktok.com/@about.u.kraine?_t=8pImRabkagg&_r=1";
export const fb = "https://www.facebook.com/About.you.and.ukraine";
export const tg = "https://t.me/yulia_martyn";

export const donate = "https://www.liqpay.ua/uk/checkout/card/i56146757479"
